import { useState } from 'react';
import HookForm from '../../../components/HookForm/HookForm';
import Select from '../../../components/Select/Select';
import editDeal from '../../../api/deals/editDeal';
import Button from '../../../components/Button/Button';
import { DEAL_STATUS_CAR_ISSUED, DEAL_STATUS_READY_FOR_CONCLUSION_OF_CREDIT_AGREEMENT } from '../../../constants';
import setStep from '../../../api/deals/setStep';

const DealCreatePledgeRegistration = ({ backHandler, deal, update }) => {
  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = () => {
    setLoading(true);

    if (deal?.status?.id === DEAL_STATUS_READY_FOR_CONCLUSION_OF_CREDIT_AGREEMENT) {
      editDeal({
        id: deal.id,
        statusId: DEAL_STATUS_CAR_ISSUED,
      })
        .then(() => {
          setStep({
            dealId: deal.id,
            step: 10,
          })
            .then(() => {
              update && update();
            })
            .finally(() => {
              setLoading(false);
            });
        })
        .catch(() => {
          setLoading(false);
        });
      return;
    }

    editDeal({
      id: deal.id,
      statusId: status ? DEAL_STATUS_READY_FOR_CONCLUSION_OF_CREDIT_AGREEMENT : deal?.status?.id,
    })
      .then(() => {
        update && update();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <HookForm
        title={'Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð·Ð°Ð»Ð¾Ð³Ð°'}
        grid={{ display: 'grid', gap: 20 }}
        action={deal?.status?.id === DEAL_STATUS_READY_FOR_CONCLUSION_OF_CREDIT_AGREEMENT ? 'ÐÐ°Ð²ÐµÑÑÐ¸ÑÑ' : 'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'}
        inputs={[]}
        onSubmit={onSubmit}
        loading={loading}
        customData={() => (
          <div
            style={{
              display: 'grid',
              gap: 20,
            }}
          >
            <div
              style={{
                display: 'grid',
                gap: 20,
                gridTemplateColumns: '1fr auto',
                alignItems: 'flex-end'
              }}
            >
              <Select
                options={[
                  {
                    value: true,
                    label: 'Ð¢Ð¡ Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð² Ð·Ð°Ð»Ð¾Ð³',
                  },
                  {
                    value: false,
                    label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð² Ð·Ð°Ð»Ð¾Ð³',
                  },
                ]}
                onChange={setStatus}
                label="Ð¡ÑÐ°ÑÑÑ Ð·Ð°Ð»Ð¾Ð³Ð°"
                placeholder="ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°"
              />
              <div>
                <Button
                  text={
                    deal?.status?.id === DEAL_STATUS_READY_FOR_CONCLUSION_OF_CREDIT_AGREEMENT
                      ? 'Ð¢Ð¡ Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð² Ð·Ð°Ð»Ð¾Ð³'.toUpperCase()
                      : 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð² Ð·Ð°Ð»Ð¾Ð³'.toUpperCase()
                  }
                  style={{ color: 'rgb(73, 65, 54)', border: '1px solid rgb(73, 65, 54)' }}
                />
              </div>
            </div>

            <div>
              <p
                style={{
                  fontWeight: 700,
                  fontSize: '20px',
                  lineHeight: '20px',
                  color: 'rgb(73, 65, 54)',
                  marginBottom: '20px',
                }}
              >
                Ð¡ÑÐ°ÑÑÑ
              </p>
              <Button
                text={deal?.status?.title?.toUpperCase()}
                style={{ color: 'rgb(73, 65, 54)', border: '1px solid rgb(73, 65, 54)' }}
              />
            </div>
          </div>
        )}
        backHandler={backHandler}
      />
    </div>
  );
};

export default DealCreatePledgeRegistration;
